<template>
    <div class="entiretyClass">
        <common-top></common-top>
        <div class="content" :style="$store.state.hasSubMenu?'margin-left:200px':'margin-left:0'">
            <common-left  v-if="$store.state.hasSubMenu"></common-left>
            <div class="commonCenter" ref="commonCenter">
                <el-scrollbar style="height: 100%;">
                    <router-view></router-view>
                </el-scrollbar>
            </div>
        </div>
    </div>
</template>

<script>
    import commonLeft from './layout/common_left'
    import commonTop from './layout/common_top'
    export default {
        name: "index",
        data(){
            return{}
        },
        components: {
            commonLeft,
            commonTop
        },
        methods: {}
    }
</script>

<style scoped lang="less">
    .entiretyClass{
        width: 100%;
        height: 100%;
        .content{
            margin-left: 200px;
            height: 100%;
            position: relative;
            .commonCenter{
                width: 100%;
                height: 100%;
                padding-top: 96px;
                /deep/.el-scrollbar__wrap {
                    overflow-x: hidden;
                }
            }
        }
    }
</style>



// WEBPACK FOOTER //
// src/views/index.vue